<script lang="ts" setup>
import type { ICellRendererParams } from 'ag-grid-community';
import type { PropType} from 'vue';
import { computed } from 'vue';
import Icon from '@/components/common/Icon.vue';

type ExtendedParams = ICellRendererParams & {
    id: string;
    title: (params: ICellRendererParams) => string;
    cssClasses: (params: ICellRendererParams) => string;
    icon: (params: ICellRendererParams) => string;
    hidden: (params: ICellRendererParams) => boolean;
    tooltip?: (params: ICellRendererParams) => string | object;
};

const props = defineProps({
    params: {
        type: Object as PropType<ExtendedParams>,
        required: true
    }
});

const title = computed(() => (typeof props.params.title === 'function' ? props.params.title(props.params) : props.params.title));
const icon = computed(() => (typeof props.params.icon === 'function' ? props.params.icon(props.params) : props.params.icon));
const cssClasses = computed(() => (typeof props.params.cssClasses === 'function' ? props.params.cssClasses(props.params) : props.params.cssClasses));
const hidden = computed(() => props.params.hidden);
const tooltip = computed(() => (typeof props.params.tooltip === 'function' ? props.params.tooltip(props.params) : props.params.tooltip));
</script>

<template>
    <div v-if="!hidden" class="flex-container align-middle align-center height-100" :title="title" data-test="ag-icon">
        <Icon v-tooltip="tooltip" :icon="icon" :class="cssClasses" />
    </div>
</template>
